import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {Loader} from 'rsuite'
import AuthService from 'src/cms/constants/authService'
import {FallbackView} from 'src/cms/partials'

function SingleSignOn(): JSX.Element {
  const authService = new AuthService()
  const navigate = useNavigate()

  useEffect(() => {
    if (authService.isAuthenticated()) {
      navigate('/')
    } else {
      authService.signInRedirect()
    }
  }, [])

  return <Loader size='lg' center />
}

export default SingleSignOn
